
export const practiceAreasList = [
    'Accounting',
    'Antitrust/Competition',
    'European Union/International Competition',
    'Sports',
    'Artificial Intelligence',
    'Banking',
    'Capital Markets',
    'Structured Finance',
    'Corporate Governance',
    'Corporate Restructuring',
    'Crisis Response and Risk Management',
    'Cybersecurity and Data Privacy',
    'Energy and Infrastructure Projects',
    'Energy Mergers and Acquisitions',
    'Energy Regulatory'
  ];
  
export const citiesList = [
    {
      title: 'Chicago, IL US',
      name: 'chicago'
    },
    {
      title: 'London, ENG',
      name: 'london'
    },
    {
      title: 'Dallas, TX US',
      name: 'dallas'
    },
    {
      title: 'Sydney, AU',
      name: 'sydney'
    },
    {
      title: 'Los Angeles, CA US',
      name: 'los angeles'
    },
    {
      title: 'Montreal, QC CA',
      name: 'montreal'
    },
    {
      title: 'New York City, NY US',
      name: 'new york city'
    },
    {
      title: 'Paris, FR',
      name: 'paris'
    },
    {
      title: 'Washington DC US',
      name: 'washington dc'
    },
    {
      title: 'Tokyo, Japan',
      name: 'tokyo'
    }
];

export const experienceData = [
    { title: "Any Experience", id: 0 },
    { title: "5+ years", id: 5 },
    { title: "10+ years", id: 10 },
    { title: "15+ years", id: 15 },
  ];
  